"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) { return ({
    header: {
        backgroundColor: theme.palette.primary.main,
        // height: 50,
        padding: 12,
        color: theme.palette.primary.contrastText
    },
    title: {
        fontSize: '0.9rem',
        color: theme.palette.primary.contrastText
    }
}); });
exports.QAHeader = function (_a) {
    var title = _a.title, titleClass = _a.titleClass, avatar = _a.avatar;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.CardHeader, { title: title, titleTypographyProps: { className: clsx_1.default(titleClass, classes.title), component: 'h3' }, className: clsx_1.default('faq-panel-header', classes.header), avatar: avatar }));
};
//# sourceMappingURL=QAHeader.js.map